export interface HubspotCompany {
  hubspotId: string;
  name: string;
}

export type SurveyCompanyReference = HubspotCompany;
